module.exports = __webpack_public_path__ + "assets/img/18_277_big.6272200e.jpg";